import { LAYOUT } from '@/constants';
import zonesImg from '@/assets/img/motd/zones.png';
import mixedImg from '@/assets/img/motd/mixed.png';
import rowsImg from '@/assets/img/motd/rows.png';
import tablesImg from '@/assets/img/motd/tables.png';

export default [
  {
    name: 'Sections',
    description: 'Seatmap by Sections with Rows inside',
    icon: 'blur_on',
    layout: LAYOUT.SECTIONS,
    img: zonesImg,
  },
  {
    name: 'Mixed',
    description: 'Seatmap with Rows and Tables',
    icon: 'view_quilt',
    layout: LAYOUT.MIXED,
    img: mixedImg,
  },
  {
    name: 'Rows',
    description: 'Seatmap with Rows only',
    icon: 'dialpad',
    layout: LAYOUT.ROWS,
    img: rowsImg,
  },
  {
    name: 'Tables',
    description: 'Seatmap with Tables only',
    icon: 'bubble_chart',
    layout: LAYOUT.TABLES,
    img: tablesImg,
  },
];
